export const ROUTES = {
  blank: "",
  Slash: "/",
  Home: "/home",
  Login: "/login",
  Register: "/register",
  Customer: "/customer",
  Tracking: "/tracking",
  CheckingStatus: "/checkingstatus",
  Queue: "/queue",
};
